import { createSlice } from '@reduxjs/toolkit';
import { logOut } from '../../../../app/reducers/authorization-slice';
import type { UserProfile } from '../../application/types';
import { userApi } from '../api/user.api';

export type UserState = {
  profile: UserProfile | null;
};

const initialState: UserState = {
  profile: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUserProfile: (state) => {
      state.profile = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logOut, (state) => {
        state.profile = null;
      })
      .addMatcher(
        userApi.endpoints.getProfile.matchFulfilled,
        (state, { payload }) => {
          state.profile = payload;
        },
      )
      .addMatcher(
        userApi.endpoints.updateProfile.matchFulfilled,
        (state, { payload }) => {
          state.profile = payload;
        },
      );
  },
});

export const { clearUserProfile } = userSlice.actions;
export default userSlice.reducer;
